( function () {
    var sections = document.querySelectorAll( '.accordion' );

    if ( ! sections.length ) {
        return;
    }

    sections.forEach( function ( section ) {
        section.classList.add( 'is-ready' );

        section.querySelectorAll( '.accordion__item' ).forEach( function ( item ) {
            var summary = item.querySelector( '.accordion__summary' );
            var answer = item.querySelector( '.accordion__answer' );

            if ( ! summary || ! answer || item.dataset.accordionReady ) {
                return;
            }

            item.dataset.accordionReady = 'true';

            summary.addEventListener( 'click', function ( event ) {
                event.preventDefault();

                if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
                    var open = ! item.classList.contains( 'is-open' );
                    item.classList.toggle( 'is-open', open );
                    item.open = open;
                    answer.style.height = open ? 'auto' : '0px';
                    return;
                }

                if ( item.classList.contains( 'is-open' ) ) {
                    closeItem( item, answer, section );
                } else {
                    openItem( item, answer, section );
                }
            } );
        } );

        setupReveal( section );
    } );

    function setupReveal( section ) {
        var header = section.querySelector( '.accordion__header' );
        var title = section.querySelector( '.accordion__title' );
        var items = Array.prototype.slice.call( section.querySelectorAll( '.accordion__item' ) );
        var styles = window.getComputedStyle( section );
        var inset = styles.getPropertyValue( '--accordion-reveal-inset' ).trim() || '12%';
        var itemsLead = parseDuration( styles.getPropertyValue( '--accordion-reveal-items-lead' ), 550 );
        var copyRevealedAt = null;
        var observer;
        var resizeTimer;

        if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches || ! ( 'IntersectionObserver' in window ) ) {
            section.setAttribute( 'data-reveal-skip', '' );
            return;
        }

        if ( ! header && ! items.length ) {
            section.setAttribute( 'data-reveal-skip', '' );
            return;
        }

        if ( title ) {
            splitTitle( title );
        }

        section.classList.add( 'is-reveal' );
        assignLines( title );

        observer = new IntersectionObserver( function ( entries ) {
            var batch = [];

            entries.forEach( function ( entry ) {
                if ( ! entry.isIntersecting ) {
                    return;
                }

                if ( entry.target === header ) {
                    revealCopy();
                } else {
                    batch.push( entry.target );
                }
            } );

            revealItems( batch );
        }, {
            rootMargin: '0px 0px -' + inset + ' 0px',
            threshold: 0
        } );

        // Let the hidden state paint before observing, so content already on screen still animates in.
        window.requestAnimationFrame( function () {
            window.requestAnimationFrame( function () {
                if ( header ) {
                    observer.observe( header );
                }

                items.forEach( function ( item ) {
                    observer.observe( item );
                } );
                revealIfPageEnds();
            } );
        } );

        onRevealPageEnd( revealIfPageEnds );
        window.addEventListener( 'resize', onResize );

        function onResize() {
            window.clearTimeout( resizeTimer );
            resizeTimer = window.setTimeout( function () {
                if ( copyRevealedAt === null ) {
                    assignLines( title );
                }

                revealIfPageEnds();
            }, 150 );
        }

        function revealIfPageEnds() {
            var atEnd = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4;
            var waiting;

            if ( ! atEnd ) {
                return;
            }

            revealCopy();
            waiting = items.filter( function ( item ) {
                return ! item.classList.contains( 'is-inview' );
            } );
            revealItems( waiting );
        }

        function revealCopy() {
            if ( ! header || copyRevealedAt !== null ) {
                return;
            }

            copyRevealedAt = Date.now();
            section.classList.add( 'is-copy-inview' );

            if ( observer ) {
                observer.unobserve( header );
            }
        }

        function revealItems( batch ) {
            var fresh = batch.filter( function ( item ) {
                return ! item.classList.contains( 'is-inview' );
            } );

            fresh.sort( function ( a, b ) {
                return items.indexOf( a ) - items.indexOf( b );
            } );

            fresh.forEach( function ( item, index ) {
                var lead = 0;

                if ( header && copyRevealedAt === null && isOnScreen( header ) ) {
                    revealCopy();
                }

                if ( copyRevealedAt !== null ) {
                    lead = Math.max( 0, itemsLead - ( Date.now() - copyRevealedAt ) );
                }

                item.style.setProperty( '--accordion-reveal-lead', lead + 'ms' );
                item.style.setProperty( '--accordion-reveal-index', String( index ) );
                item.classList.add( 'is-inview' );
                observer.unobserve( item );
            } );
        }
    }

    function onRevealPageEnd( callback ) {
        if ( window.JPSReveal ) {
            window.JPSReveal.onEnd( callback );
            return;
        }

        window.addEventListener( 'scroll', callback, { passive: true } );
    }

    function splitTitle( title ) {
        var text = title.textContent;
        var fragment = document.createDocumentFragment();

        title.setAttribute( 'aria-label', text.trim() );

        text.split( /(\s+)/ ).forEach( function ( part ) {
            var mask;
            var word;

            if ( ! part ) {
                return;
            }

            if ( /^\s+$/.test( part ) ) {
                fragment.appendChild( document.createTextNode( ' ' ) );
                return;
            }

            mask = document.createElement( 'span' );
            mask.className = 'accordion__title-mask';
            mask.setAttribute( 'aria-hidden', 'true' );

            word = document.createElement( 'span' );
            word.className = 'accordion__title-word';
            word.textContent = part;

            mask.appendChild( word );
            fragment.appendChild( mask );
        } );

        title.textContent = '';
        title.appendChild( fragment );
    }

    function assignLines( title ) {
        var line = -1;
        var lastTop = null;

        if ( ! title ) {
            return;
        }

        title.querySelectorAll( '.accordion__title-mask' ).forEach( function ( mask ) {
            var top = mask.offsetTop;

            if ( lastTop === null || Math.abs( top - lastTop ) > 4 ) {
                line++;
                lastTop = top;
            }

            mask.firstChild.style.setProperty( '--accordion-reveal-line', String( line ) );
        } );
    }

    function isOnScreen( element ) {
        var rect = element.getBoundingClientRect();

        return rect.top < window.innerHeight && rect.bottom > 0;
    }

    function parseDuration( raw, fallback ) {
        raw = ( raw || '' ).trim();

        if ( raw.slice( -2 ) === 'ms' ) {
            return parseFloat( raw ) || fallback;
        }

        return ( parseFloat( raw ) * 1000 ) || fallback;
    }

    function openItem( item, answer, section ) {
        var token = nextToken( item );

        item.open = true;
        answer.style.height = answer.getBoundingClientRect().height + 'px';
        var target = answer.scrollHeight;
        answer.offsetHeight;
        item.classList.add( 'is-open' );
        answer.style.height = target + 'px';

        afterHeight( answer, section, function () {
            if ( item.dataset.motion !== token || ! item.classList.contains( 'is-open' ) ) {
                return;
            }

            answer.style.height = 'auto';
        } );
    }

    function closeItem( item, answer, section ) {
        var token = nextToken( item );

        answer.style.height = answer.getBoundingClientRect().height + 'px';
        answer.offsetHeight;
        item.classList.remove( 'is-open' );
        answer.style.height = '0px';

        afterHeight( answer, section, function () {
            if ( item.dataset.motion !== token || item.classList.contains( 'is-open' ) ) {
                return;
            }

            item.open = false;
            answer.style.height = '0px';
        } );
    }

    function nextToken( item ) {
        item.dataset.motion = String( ( Number( item.dataset.motion ) || 0 ) + 1 );
        return item.dataset.motion;
    }

    function afterHeight( answer, section, done ) {
        var finished = false;
        var finish = function ( event ) {
            if ( finished || ( event && ( event.target !== answer || event.propertyName !== 'height' ) ) ) {
                return;
            }

            finished = true;
            answer.removeEventListener( 'transitionend', finish );
            done();
        };

        answer.addEventListener( 'transitionend', finish );
        window.setTimeout( finish, durationMs( section ) + 80 );
    }

    function durationMs( section ) {
        var raw = window.getComputedStyle( section ).getPropertyValue( '--accordion-toggle-duration' ).trim();

        if ( raw.slice( -2 ) === 'ms' ) {
            return parseFloat( raw ) || 450;
        }

        return ( parseFloat( raw ) || 0.45 ) * 1000;
    }
} )();
